import type { CrfComputed, CrfVerdict } from '@/types/mentorEngagements';

/**
 * The computed CRF verdict as the mentor sees it before saving (ENG-R26).
 *
 * Mirrors `aggregate_crf` in backend/app/services/mentor_forms/aggregation.py:
 * "demonstrated" when every C3–C8 gate is met and Competency 1 is verified.
 * The C1 switch is local until the CRF is saved, so the server's
 * `computed.verdict` still reflects the stored C1 value; applying the switch
 * here keeps the selected verdict and the override warning honest.
 */
export function liveComputedVerdict(
  computed: Pick<CrfComputed, 'gates' | 'verdict'> | null | undefined,
  c1Verified: boolean,
): CrfVerdict {
  if (!computed) return 'not_yet';
  const gates = Object.values(computed.gates ?? {});
  if (gates.length === 0) return computed.verdict;
  return gates.every((gate) => gate.met) && c1Verified ? 'demonstrated' : 'not_yet';
}
